import { render, staticRenderFns } from "./recordAudio.vue?vue&type=template&id=0858ee40&scoped=true"
import script from "./recordAudio.vue?vue&type=script&lang=js"
export * from "./recordAudio.vue?vue&type=script&lang=js"
import style0 from "./recordAudio.vue?vue&type=style&index=0&id=0858ee40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0858ee40",
  null
  
)

export default component.exports